export const AiResponseContentType = {
  MARKDOWN: 'markdown',
  CSV: 'csv',
  JSON: 'json',
  TABLE: 'table',
  LINK: 'link',
  MULTI: 'multi',
  GRAPH: 'graph',
  DIARY: 'diary',
  RANK_LIST: 'rankList',
  AGENT_SWITCH: 'agentSwitch'
};

export class ContentSegment {
  /**
   * @param {object} params
   * @param {string} params.type - The type of content, from AiResponseContentType.
   * @param {any} params.data - The content data.
   * @param {string|null} [params.title=null] - An optional title for the segment.
   */
  constructor({ type, data, title = null }) {
    this.type = type;
    this.data = data;
    this.title = title;
  }
}

export class ParsedContent {
  /**
   * @param {object} params
   * @param {string} params.type - The overall type of content, from AiResponseContentType.
   * @param {any} [params.data=null] - The data, if type is not 'multi'.
   * @param {Array<ContentSegment>|null} [params.segments=null] - The segments, if type is 'multi'.
   */
  constructor({ type, data = null, segments = null }) {
    this.type = type;
    this.data = data;
    this.segments = segments;
  }
} 